  angular
  .module('vppApp')
  .service('TimeOutService', TimeOutService);

  TimeOutService.$inject = ['$http', '$state', 'AuthenticationService', '$interval'];

  function TimeOutService($http, $state, AuthenticationService, $interval) {

    var timeOutService = {};
    var _lastDigestRun;
    var _idleCheck;

    timeOutService.checkAuthError = function (response) {
      if (response.data.errors[0].errorCode === '9401') {
        timeOutService.cancleTimeOut();
        AuthenticationService.destroyAuthentication();
        $state.go('index');
      }
    };

    timeOutService.checkForTimeOut = function () {
      if (AuthenticationService.isAuthenticated()) {

        if (!_idleCheck) {
          _startIdleCheck();
        }
      } else if (_idleCheck) {
        //console.log("checkForTimeOut elseee" + AuthenticationService.isAuthenticated() + " : " + _idleCheck);
        this.cancleTimeOut();
      }

    };

    var _startIdleCheck = function () {
      _idleCheck = $interval(function () {
        var now = Date.now();
        //console.log("running " + now + " : " + _lastDigestRun);
        //if (now - lastDigestRun > 15*60*1000) {
        if (now - _lastDigestRun > 900000) {
          // logout
          console.log("Log OUT ~~~~~~ " + " : " + now + " : " + _lastDigestRun);
          timeOutService.cancleTimeOut();
          AuthenticationService.destroyAuthentication();
          $state.go('index');
        }
      }, 60 * 1000);

    };

    timeOutService.cancleTimeOut = function () {
      console.log("cancleTimeout");
      $interval.cancel(_idleCheck);
      _idleCheck = null;
    };

    timeOutService.setLastDigestRun = function () {
      _lastDigestRun = Date.now();
    };

    return timeOutService;
  };